export default "__VITE_ASSET__UHk00SCz__"